import { gql } from 'apollo-angular';

const GET_LIGHTING_CONSUMPTION = gql`
  query LightingConsumption(
    $company: ID!
    $startDatetime: DateTime!
    $endDatetime: DateTime!
    $installationId: ID
    $page_size: Int
    $page_cursor: String
  ) {
    lightingConsumption(
      company: $company
      startDatetime: $startDatetime
      endDatetime: $endDatetime
      installation: $installationId
      pageSize: $page_size
      cursor: $page_cursor
    ) {
      count
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          installation
          datetime
          consumption
          meterCurrentConsumption
          operatingVoltage
          powerFactor
          timestampDiff
          createdAt
        }
      }
    }
  }
`;

const GET_READ_CONSUMPTION = gql`
  query ReadConsumption(
    $company: ID!
    $startDatetime: DateTime!
    $endDatetime: DateTime!
    $installationId: ID
    $page_size: Int
    $page_cursor: String
  ) {
    readConsumption(
      company: $company
      startDatetime: $startDatetime
      endDatetime: $endDatetime
      installation: $installationId
      pageSize: $page_size
      cursor: $page_cursor
    ) {
      count
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          installation
          datetime
          consumption
          activeReverseEnergy
          capacitiveReactiveEnergy
          inductiveReactiveEnergy
          timestampDiff
          createdAt
        }
      }
    }
  }
`;
const GET_PULSE_CONSUMPTION = gql`
  query PulseConsumption(
    $company: ID!
    $startDatetime: DateTime!
    $endDatetime: DateTime!
    $installationId: ID
    $counter: Int
    $page_size: Int
    $page_cursor: String
  ) {
    pulseConsumption(
      company: $company
      startDatetime: $startDatetime
      endDatetime: $endDatetime
      installation: $installationId
      counter: $counter
      pageSize: $page_size
      cursor: $page_cursor
    ) {
      count
      total
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          installation
          datetime
          consumption
          counter
          pulseCount
          pulseCountDiff
          pulseCountWeight
          timestampDiff
          createdAt
        }
      }
    }
  }
`;

export {
  GET_LIGHTING_CONSUMPTION,
  GET_READ_CONSUMPTION,
  GET_PULSE_CONSUMPTION,
};
